import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export default styled(Link)`

`;
